import { Info } from "lucide-react";

import { ColocaIconButton } from "@/shared/components/buttons/ColocaIconButton";
import { ColocaDialog } from "@/shared/components/overlays/ColocaDialog";
import useTranslations from "@/shared/lang/useTranslations";

export function ThreeDsInfoButton() {
  const { t } = useTranslations("cards");

  return (
    <ColocaDialog
      trigger={
        <ColocaIconButton
          type="button"
          variant="ghost"
          size="xs"
          icon={Info}
          aria-label={t("phone_usage_info_button_label")}
          // Contained attention pulse (opacity only — no scaling ring that would
          // overlap the input or shift the layout).
          className="size-5 animate-pulse text-primary"
        />
      }
      title={t("phone_usage_modal_title")}
      size="default"
    >
      <div className="space-y-3 text-sm text-muted-foreground">
        <p>{t("phone_usage_modal_intro")}</p>
        <ul className="list-disc space-y-2 pl-5">
          <li>{t("phone_usage_item_3ds")}</li>
          <li>{t("phone_usage_item_whatsapp")}</li>
        </ul>
        <p>{t("phone_usage_modal_note")}</p>
      </div>
    </ColocaDialog>
  );
}
